import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConditionInfo, ModalInfo } from '../../../shared/models';
import { ScrollbarModule } from '../../../scrollbar/scrollbar.module';
import { FeatureTagComponent } from '../components/feature-tag/feature-tag.component.component';
import { ModalActionsComponent } from './modal-actions';
import { ModalDirective } from './modal.directive';
import { ModalHeadComponent } from './modal-head';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ScrollbarModule,
    FeatureTagComponent,
    ModalHeadComponent,
    ModalActionsComponent,
    ModalDirective,
  ],
})
export class ModalComponent {
  @Input() info: ModalInfo;
  @Input() loadingInfo: ConditionInfo = { condition: false };
  @Input() formUnchangedInfo: ConditionInfo = { condition: false };

  @ContentChild('scrollableContent') scrollableContent: TemplateRef<ElementRef>;
  @ContentChild('contentOnHeader') contentOnHeader: TemplateRef<ElementRef>;

  @ContentChild('titleContent') titleContent: TemplateRef<ElementRef>;
  @ContentChild('textContent') textContent: TemplateRef<ElementRef>;

  @ContentChild('closeModalBtnContent')
  closeModalBtnContent: TemplateRef<ElementRef>;
  @ContentChild('submitWithClothingContent')
  submitWithClothingContent: TemplateRef<ElementRef>;
  @ContentChild('customActionBtnContent')
  customActionBtnContent: TemplateRef<ElementRef>;

  @Output() closeModal = new EventEmitter<any>();
  @Output() onSubmit = new EventEmitter<null>();

  clickCloseModal(data: any = null): void {
    this.closeModal.emit(data);
  }

  clickOnSubmit(): void {
    this.onSubmit.emit(null);
  }
}
